import React, { useEffect, useState } from "react";
import { Alert, Container } from "reactstrap";
import { showTopbarInsideAction } from "../../../store/actions";
import { useDispatch } from "react-redux";
import HeaderDefaultToPage from "../../../components/Common/headerDefaultToPage";

const NO005 = () => {
  document.title = "Defender | Minha Segurança";

  const dispatch = useDispatch();
  const [messageAlert, setmessageAlert] = useState(null);

  const handleButton = (idDevice) => {
    setmessageAlert({message: "Pendente implantação do backend.", color: "warning"})
  };

  const handleSubmit= (e) => {
    e.preventDefault()

    setmessageAlert({message: "Pendente implantação do backend.", color: "warning"})
  }

  useEffect(() => {
    dispatch(showTopbarInsideAction({}));
  }, []);

  return (
    <React.Fragment>
      <div className="page-content page-config">
        <Container fluid={true} className="dataTable-custom-primary">
          <HeaderDefaultToPage
            goBackPage={"/BI_WS0002"}
            title={"Minha Segurança"}
          />
          <div className="row content-page my-4">
            <div className="col-lg-4 col-md-5 col-12">
              <div className="bg-white card-content w-100">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <h5 className="m-0 font-size-20 font-w-600 text-primary-dark">
                      Dispositivos de Acesso
                    </h5>
                  </div>
                  <form
                    className="row mt-4 form-devices-access"
                    onSubmit={handleSubmit}
                  >
                    {messageAlert && (
                      <div className="form-grop">
                        <Alert color={messageAlert.color}>
                          {messageAlert.message}
                        </Alert>
                      </div>
                    )}
                    <div className="col-12 form-group mb-3">
                      <label>Canal de comunicação para verificação</label>
                      <ul className="ul-list-custom">
                        <li className="border-bottom px-3">
                          <div
                            className="d-flex align-items-center justify-content-between"
                          >
                            <div className="d-flex align-items-center gap-3">
                              <i className="fas fa-laptop"></i>
                              <span>Windows</span>
                              <span className="describe-device py-1">LAPTOP-GG24</span>
                            </div>
                            <button type="button" onClick={handleButton} className="btn-log-in-out-device">Deslogar</button>
                          </div>
                        </li>
                        <li className="border-bottom px-3">
                          <div
                            className="d-flex align-items-center justify-content-between"
                          >
                            <div className="d-flex align-items-center gap-3">
                              <i className="fas fa-laptop"></i>
                              <span>Windows</span>
                              <span className="describe-device py-1">LAPTOP-GG24</span>
                            </div>
                            <button type="button" onClick={handleButton} className="btn-log-in-out-device">Deslogar</button>
                          </div>
                        </li>
                        <li className="px-3 mb-4">
                          <div
                            className="d-flex align-items-center justify-content-between"
                          >
                            <div className="d-flex align-items-center gap-3">
                              <i className="fas fa-laptop"></i>
                              <span>Device</span>
                              <span className="describe-device py-1">Xiomi Mi A2</span>
                            </div>
                            <button type="button" onClick={handleButton} className="btn-log-in-out-device">Deslogar</button>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="col-12 align-items-center d-flex">
                      <button className="btn-link-page" type="submit">
                        Deslogar de todos os dispositivos
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default NO005;
